import React from 'react';
import formatCurrency from '../../func/currency_formatter';

const CardHalfBundle = ({ handleCardClick, styles, labels, data, displayBadges, outOfStock }) => {
	let totalPrice = data.formatted_total_amount
		? data.formatted_total_amount
		: formatCurrency(data.amount * data.price);
	let oldPrice = data?.formatted_old_price ? data?.formatted_old_price : formatCurrency(Number(data?.old_price));

	if (outOfStock) {
		totalPrice = window.formattedString
			? window.formattedString.replace(/0.00|0,00/g, Number(1 * data?.amount).toFixed(2))
			: formatCurrency(Number(1.0 * data.amount));
		oldPrice = window.formattedString
			? window.formattedString.replace(/0.00|0,00/g, '1.00')
			: formatCurrency(Number(1));
	}

	return (
		<div className="productsColumns__item" style={styles?.card} onClick={handleCardClick}>
			<div className="productsColumns__itemHeading productsColumns__itemHeading--active" style={styles?.heading}>
				{outOfStock ? 'Out Of Stock' : data.status}
			</div>
			<div className="productsColumns__itemContentWrap">
				<div className="image__wrapper--alt">
					<img
						src={data.image.url}
						alt="product x4"
						style={{ height: '100%', width: 'auto' }}
						className="mon-img-177-h"
					/>
				</div>
				{displayBadges && !outOfStock && (
					<div className="productsRows__itemPerks productsRows__itemPerks--active productsRows__itemPerks--package only-mobile-badges">
						<div style={styles?.shippingBadge}>{labels?.shipping}</div>
						<div style={styles?.savingsBadge}>
							{labels?.saveLabel} -{data.you_save_percentage}%
						</div>
					</div>
				)}
				<div className="itemPackageContent">
					<div className="itemPackageContent__itemNumber" style={styles?.primaryColor}>
						{data.amount}x
					</div>
					<div className="itemPackageContent__itemName" style={styles?.primaryColor}>
						{data.display_name}
					</div>
					<div className="itemPackageContent__itemTotal" style={styles?.priceColor}>
						{totalPrice}
					</div>
					<div className="itemPackageContent__itemTotalDiscount" style={styles?.secondaryColor}>
						{!outOfStock && oldPrice}
					</div>
				</div>
			</div>
		</div>
	);
};

export default CardHalfBundle;
